<div class="login-page">
  <div class="login-content">
    <div class="login-logo-section">
      <app-decal
        [decal]="(tema$ | async)?.payload?.decalLogoLogin"
        anchor="top-right"
      >
        <img
          [src]="
            helper.darkTheme
              ? 'assets/images/irix_logo_dark.png'
              : 'assets/images/irix_logo.png'
          "
          alt="IRIX"
          class="login-logo"
        />
      </app-decal>
      <span class="login-tagline">Inteligencia que protege</span>
    </div>

    <app-decal
      [decal]="(tema$ | async)?.payload?.decalLogin"
      anchor="bottom-right"
    >
      <mat-card class="login-card" appearance="outlined">
        @if (form) {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <mat-form-field
              appearance="outline"
              subscriptSizing="fixed"
              class="login-field"
            >
              <mat-label>Usuario</mat-label>
              <mat-icon matPrefix>person</mat-icon>
              <input
                matInput
                type="text"
                required
                formControlName="usuario"
                autocomplete="username"
              />
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              subscriptSizing="fixed"
              class="login-field"
            >
              <mat-label>Contraseña</mat-label>
              <mat-icon matPrefix>lock</mat-icon>
              <input
                matInput
                [type]="inputType"
                required
                formControlName="password"
                autocomplete="current-password"
              />
              <button
                irxBotonIcono
                matSuffix
                [tooltip]="
                  inputType === 'password'
                    ? 'Mostrar contraseña'
                    : 'Ocultar contraseña'
                "
                (click)="onClickShowPassword()"
              >
                <mat-icon>
                  {{
                    inputType === 'password' ? 'visibility' : 'visibility_off'
                  }}
                </mat-icon>
              </button>
            </mat-form-field>

            <button
              irxBoton="principal"
              bloque
              tamano="campo"
              type="submit"
              class="login-button"
              [disabled]="loading.getLoading()"
            >
              <mat-icon>login</mat-icon>
              Ingresar
            </button>

            <div class="forgot-password-link">
              <a
                class="forgot-link irx-enlace"
                role="button"
                tabindex="0"
                (click)="goToForgotPassword()"
                (keydown.enter)="goToForgotPassword()"
              >
                ¿Olvidaste tu contraseña?
              </a>
            </div>

            <div class="register-link">
              ¿No tenés cuenta?
              <a
                class="forgot-link irx-enlace"
                role="button"
                tabindex="0"
                (click)="goToRegistro()"
                (keydown.enter)="goToRegistro()"
              >
                Registrate
              </a>
            </div>
          </form>

          @if (googleHabilitado) {
            <div
              style="
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 16px 0;
                color: var(--theme-text-secondary, #888);
              "
            >
              <span
                style="
                  flex: 1;
                  height: 1px;
                  background: currentColor;
                  opacity: 0.3;
                "
              ></span>
              <span style="font-size: 0.85rem">o</span>
              <span
                style="
                  flex: 1;
                  height: 1px;
                  background: currentColor;
                  opacity: 0.3;
                "
              ></span>
            </div>
            <div style="display: flex; justify-content: center">
              <div #googleBtn></div>
            </div>
          }
        }

        <mat-progress-bar
          color="primary"
          [mode]="loading.getLoading() ? 'indeterminate' : 'determinate'"
          class="login-progress"
        ></mat-progress-bar>
      </mat-card>
    </app-decal>
  </div>

  <footer class="login-footer">
    {{ envService.APP_VERSION }} · &copy; GPE Sistemas 2026
  </footer>
</div>
